window.axios = require('axios');
window.Vue = require('vue');

/*
 * Load jQuery and Bootstrap jQuery, used for front-end interaction.
 */
if (window.$ === undefined || window.jQuery === undefined) {
    window.$ = window.jQuery = require("jquery");
}

$(function () {
    $('.chosen').chosen();
});

require("popper.js");
require("bootstrap");

require("./components/bootstrap");
require("./services/bootstrap");

import moment from 'moment';

import Paginate from 'vuejs-paginate';
Vue.component('paginate', Paginate);

import vSelect from 'vue-select';
Vue.component('v-select', vSelect);

// import vueJustgage from 'vue-justgage';
// Vue.use(vueJustgage);

//Start an events bus
window.Bus = new Vue();

new Vue({
    el: "#app-root",
});

Vue.filter('capitalize', (value) => {
    if (!value) {
        return '';
    }

    value = value.toString();

    return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('currency', (value) => {
    return value != null ? '£' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : value;
});

Vue.filter('UKDateTime', (value) => {
    return moment(value).format("DD/MM/YYYY HH:mm");
});